import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dark-mode"
export default class extends Controller {
  static targets = ["toggle", "indicator", "track"]

  connect() {
    // Load dark mode preference from localStorage
    const darkMode = JSON.parse(localStorage.getItem('darkMode') || 'false')
    this.applyDarkMode(darkMode)
    if (this.hasToggleTarget) {
      this.toggleTarget.checked = darkMode
    }
  }

  toggle(event) {
    const darkMode = event.target.checked
    localStorage.setItem('darkMode', JSON.stringify(darkMode))
    this.applyDarkMode(darkMode)
  }

  applyDarkMode(enabled) {
    if (enabled) {
      document.documentElement.classList.add('dark', 'text-bodydark', 'bg-boxdark-2')
      if (this.hasIndicatorTarget) {
        this.indicatorTarget.classList.add('translate-x-6')
        this.indicatorTarget.classList.remove('translate-x-0')
      }
      if (this.hasTrackTarget) {
        this.trackTarget.classList.add('bg-primary')
        this.trackTarget.classList.remove('bg-stroke')
      }
    } else {
      document.documentElement.classList.remove('dark', 'text-bodydark', 'bg-boxdark-2')
      if (this.hasIndicatorTarget) {
        this.indicatorTarget.classList.remove('translate-x-6')
        this.indicatorTarget.classList.add('translate-x-0')
      }
      if (this.hasTrackTarget) {
        this.trackTarget.classList.remove('bg-primary')
        this.trackTarget.classList.add('bg-stroke')
      }
    }
  }
}
